import { useQuery } from "@tanstack/react-query";
import type {
  ChangelogAppResponse,
  ChangelogEntryAdmin,
  KbArticleAdmin,
  KbArticleAdminRow,
  KbArticleDto,
  KbCategoryDto,
  KbIndexResponse,
  KbSearchHit,
} from "@klantpunt/shared";
import { api } from "../../lib/api";

export const kbAdminKey = ["helpcenter"] as const;
export const kbCategoriesKey = [...kbAdminKey, "categories"] as const;
export const kbArticlesKey = [...kbAdminKey, "articles"] as const;
export const kbArticleKey = (id: string) => [...kbAdminKey, "article", id] as const;

export const useKbCategories = () =>
  useQuery({ queryKey: kbCategoriesKey, queryFn: () => api<KbCategoryDto[]>("/helpcenter/categories") });
export const useKbArticles = () =>
  useQuery({ queryKey: kbArticlesKey, queryFn: () => api<KbArticleAdminRow[]>("/helpcenter/articles") });
export const useKbArticle = (id: string | undefined) =>
  useQuery({
    queryKey: kbArticleKey(id ?? ""),
    queryFn: () => api<KbArticleAdmin>(`/helpcenter/articles/${id}`),
    enabled: Boolean(id),
  });

// Hulp in de app
export const useKbIndex = () =>
  useQuery({ queryKey: ["help", "kb"], queryFn: () => api<KbIndexResponse>("/help/kb"), staleTime: 60_000 });
export const useKbSearch = (q: string) =>
  useQuery({
    queryKey: ["help", "kb", "search", q],
    queryFn: () => api<KbSearchHit[]>(`/help/kb/search?q=${encodeURIComponent(q)}`),
    enabled: q.length >= 2,
    placeholderData: (prev) => prev,
  });
export const useKbPublished = (slug: string | undefined) =>
  useQuery({
    queryKey: ["help", "kb", "article", slug],
    queryFn: () => api<KbArticleDto>(`/help/kb/articles/${slug}`),
    enabled: Boolean(slug),
  });

// Changelog (§6)
export const changelogAdminKey = [...kbAdminKey, "changelog"] as const;
export const useChangelogAdmin = () =>
  useQuery({ queryKey: changelogAdminKey, queryFn: () => api<ChangelogEntryAdmin[]>("/helpcenter/changelog") });
export const changelogAppKey = ["help", "changelog"] as const;
export const useChangelogApp = (enabled = true) =>
  useQuery({
    queryKey: changelogAppKey,
    queryFn: () => api<ChangelogAppResponse>("/help/changelog"),
    enabled,
    staleTime: 5 * 60_000,
  });
